import { render } from "./InfoCardComponent.vue?vue&type=template&id=2bea365c&scoped=true"
import script from "./InfoCardComponent.vue?vue&type=script&lang=js"
export * from "./InfoCardComponent.vue?vue&type=script&lang=js"

import "./InfoCardComponent.vue?vue&type=style&index=0&id=2bea365c&lang=scss&scoped=true"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bea365c"]])

export default __exports__